<template lang="pug">
    div
        v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
            template(v-slot:activator='{ on, attrs }')
                div(v-bind='attrs' v-on='on')
                    v-card.elevation-0(height="400" style="border-radius:0")
                        div(id="map")
            v-card
                v-card-title.font-weight-bold.mt-n1 Update Location
                v-card-text.my-n2
                    v-row.px-3
                        v-text-field(v-model="newLat" outlined label="Latitude")
                    v-row.px-3
                        v-text-field(v-model="newLng" outlined label="Longitude")
                    v-row.px-3
                        v-select(v-model="newZoom" outlined label="Map Zoom" :items="zoomValue")
                v-card-actions
                    v-spacer
                    v-btn.mb-2(small text @click.native="openEditDialog = false; newLat = location.lat; newLng = location.lng; newZoom = mapZoom;") Cancel
                    v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeCoordinate()") Update
</template>
<script>
export default {
    props:["location"],
    data(){
        return{
            openEditDialog:false,
            newLat:0.0,
            newLng:0.0,
            newZoom:0,
            mapZoom:16,
            map:null,
            marker:null,
            zoomValue:[16,17,18,19,20]
        };
    },
    mounted(){
        this.newLat = this.location.lat,
        this.newLng = this.location.lng,
        this.newZoom = this.mapZoom,
        this.initMap(),
        this.setMarker()
    },
    methods:{
        initMap(){
            this.map = new window.google.maps.Map(document.getElementById("map"), {
                center: {lat:this.location.lat, lng:this.location.lng},
                zoom: this.mapZoom,
            })
        },
        setMarker(){
            var markerIcon = {
                url: require('@/assets/images/markerYezzaPink.png'),
                // url: require('@/assets/images/markerYezzaBlue.png'),
                // url: 'http://image.flaticon.com/icons/svg/252/252025.svg',
                // url: 'https://img.icons8.com/color/344/google-maps-new.png',
                scaledSize: new window.google.maps.Size(60, 50),
                // origin: new window.google.maps.Point(0, 0),
                // anchor: new window.google.maps.Point(32, 65),
                // labelOrigin: new window.google.maps.Point(25,60),
            };
            this.marker = new window.google.maps.Marker({
                position: {lat:this.location.lat, lng:this.location.lng},
                map: this.map,
                icon: markerIcon,
                // label:{
                //     text:name,
                //     fontSize:"15px",
                //     fontWeight:"bold"
                // },
            })
        },
        changeCoordinate(){
            this.location.lat = parseFloat(this.newLat),
            this.location.lng = parseFloat(this.newLng),
            this.mapZoom = this.newZoom,
            this.openEditDialog = false,
            this.initMap(),
            this.setMarker()
        }
    },
}
</script>
<style scoped>
    #map{
        height: 100%;
        width: 100%;
		background: lightgray;
    }
</style>